import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-installment-payment',
  templateUrl: './request-installment-payment.component.html',
  styleUrls: ['./request-installment-payment.component.scss']
})
export class RequestInstallmentPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
